export const enum WarningCode {
	MAPI_ADDRESS_MAILTO = 'MAPI_ADDRESS_MAILTO',
	MAPI_ADDRESS_NOT_RESOLVED = 'MAPI_ADDRESS_NOT_RESOLVED',
	MAPI_ADDRESS_WRONG_TYPE = 'MAPI_ADDRESS_WRONG_TYPE',
	MAPI_ADDRESS_NAME_DIFF = 'MAPI_ADDRESS_NAME_DIFF',
	MAPI_ADDRESS_SMTP_DIFF = 'MAPI_ADDRESS_SMTP_DIFF',
	MAPI_ADDRESS_UNKNOWN_RECP_TYPE = 'MAPI_ADDRESS_UNKNOWN_RECP_TYPE',

	MAPI_ATTACH_NAMED_WRONG = 'MAPI_ATTACH_NAMED_WRONG',
	MAPI_ATTACH_NO_METHOD = 'MAPI_ATTACH_NO_METHOD',
	MAPI_ATTACH_NO_OBJECT = 'MAPI_ATTACH_NO_OBJECT',
	MAPI_ATTACH_BUFFER_AND_OBJECT = 'MAPI_ATTACH_BUFFER_AND_OBJECT',
	MAPI_ATTACH_NO_BUFFER = 'MAPI_ATTACH_NO_BUFFER',

	MAPI_HTML_BUFFER_ALL_NULL = 'MAPI_HTML_BUFFER_ALL_NULL',
	MAPI_HTML_ENC_MISMATCH = 'MAPI_HTML_ENC_MISMATCH',
	MAPI_RTFINSYNC_IGNORED = 'MAPI_RTFINSYNC_IGNORED',

	EMAIL_HEADERS_BAD_LINES_SKIPPED = 'EMAIL_HEADERS_BAD_LINES_SKIPPED',
	EMAIL_HEADERS_BAD_LINES_UNFOLDED = 'EMAIL_HEADERS_BAD_LINES_UNFOLDED',
	EMAIL_HEADERS_NON_ASCII = 'EMAIL_HEADERS_NON_ASCII',

	EMAIL_HEADERS_RECEIVED_COMBINED = 'EMAIL_HEADERS_RECEIVED_COMBINED',
	EMAIL_HEADERS_RECEIVED_UNPARSABLE = 'EMAIL_HEADERS_RECEIVED_UNPARSABLE',

	MIME_MULTIPART_PREAMBLE = 'MIME_MULTIPART_PREAMBLE',
	MIME_MULTIPART_EPILOGUE = 'MIME_MULTIPART_EPILOGUE',
	MIME_MULTIPART_0_BODIES = 'MIME_MULTIPART_0_BODIES',

	EMAIL_IDS_APPLE_MAIL_BRACKETS = 'EMAIL_IDS_APPLE_MAIL_BRACKETS',
	EMAIL_IDS_FOXMAIL_HEX_SUFFIX = 'EMAIL_IDS_FOXMAIL_HEX_SUFFIX',
	EMAIL_IDS_GREATER_THAN_A_SUFFIX = 'EMAIL_IDS_GREATER_THAN_A_SUFFIX',
	EMAIL_IDS_A_LESS_THAN_SUFFIX = 'EMAIL_IDS_A_LESS_THAN_SUFFIX',
	EMAIL_IDS_TRUNCATED = 'EMAIL_IDS_TRUNCATED',
	EMAIL_IDS_NESTED_BRACKETS = 'EMAIL_IDS_NESTED_BRACKETS',
	EMAIL_IDS_UNPARSABLE = 'EMAIL_IDS_UNPARSABLE',
	EMAIL_IDS_SENDMAIL_WRAP = 'EMAIL_IDS_SENDMAIL_WRAP',
	EMAIL_IDS_ASCII_AS_UNICODE = 'EMAIL_IDS_ASCII_AS_UNICODE',

	EMAIL_UUENCODED_ATTS = 'EMAIL_UUENCODED_ATTS',
	EMAIL_BODY_RTF_TABLES_CORRUPT = 'EMAIL_BODY_RTF_TABLES_CORRUPT',

	CSV_NOT_CSV = 'CSV_NOT_CSV',
	TSV_NOT_TSV = 'TSV_NOT_TSV',
	DAT_NOT_DAT = 'DAT_NOT_DAT',
	TXT_IS_CSV = 'TXT_IS_CSV',
	TXT_IS_DAT = 'TXT_IS_DAT',

	DAT_BOM_DELIM_MISMATCH = 'DAT_BOM_DELIM_MISMATCH',
	DAT_ENCODING_GUESSED = 'DAT_ENCODING_GUESSED',
	DAT_UTF8_IN_CP1252 = 'DAT_UTF8_IN_CP1252',

	OPT_PAGE_COUNT_COLUMN_5 = 'OPT_PAGE_COUNT_COLUMN_5',
	OPT_PAGES_KEEP_DOC_ID = 'OPT_PAGES_KEEP_DOC_ID',
	OPT_NO_PAGE_COUNT = 'OPT_NO_PAGE_COUNT',
	OPT_PATHS_WITH_COMMAS = 'OPT_PATHS_WITH_COMMAS',
	LFP_IMAGE_FORMAT_COLUMN_6 = 'LFP_IMAGE_FORMAT_COLUMN_6',

	PROD_LOAD_FILE_CONFLICT = 'PROD_LOAD_FILE_CONFLICT',
	PROD_LOAD_FILE_MISSING = 'PROD_LOAD_FILE_MISSING',
	PROD_LOAD_FILE_ERROR = 'PROD_LOAD_FILE_ERROR',
	PROD_LOAD_FILE_VALUE_MISSING = 'PROD_LOAD_FILE_VALUE_MISSING',
	PROD_LOAD_FILE_VALUE_UNPARSABLE = 'PROD_LOAD_FILE_VALUE_UNPARSABLE',
	PROD_LOAD_FILE_VALUE_CONFLICT = 'PROD_LOAD_FILE_VALUE_CONFLICT',
	PROD_LOAD_FILE_VALUE_MISMATCH = 'PROD_LOAD_FILE_VALUE_MISMATCH',
	PROD_LOAD_FILE_OUT_OF_ORDER = 'PROD_LOAD_FILE_OUT_OF_ORDER',

	PROD_FILE_UNKNOWN = 'PROD_FILE_UNKNOWN',
	PROD_FILE_MISSING = 'PROD_FILE_MISSING',
	PROD_FILE_NOT_BATES_NAMED = 'PROD_FILE_NOT_BATES_NAMED',
	PROD_FILE_CONFLICT = 'PROD_FILE_CONFLICT',
	PROD_FILE_EXTRA = 'PROD_FILE_EXTRA',
	PROD_DIR_CONFLICT = 'PROD_DIR_CONFLICT',
	PROD_DIR_NAME = 'PROD_DIR_NAME',
	PROD_DIR_MISSING = 'PROD_DIR_MISSING',
	PROD_DIR_EMPTY = 'PROD_DIR_EMPTY',

	PROD_TABLE_COLUMN_UNKNOWN = 'PROD_TABLE_COLUMN_UNKNOWN',
	PROD_TABLE_BAD_MERGE = 'PROD_TABLE_BAD_MERGE',

	PROD_BATES_MULTIPLE_SCHEMAS = 'PROD_BATES_MULTIPLE_SCHEMAS',
	PROD_BATES_SUB_RANGES = 'PROD_BATES_SUB_RANGES',
	PROD_BATES_MULTIPLE_DIGITS = 'PROD_BATES_MULTIPLE_DIGITS',
	PROD_BATES_NONSEQUENTIAL = 'PROD_BATES_NONSEQUENTIAL',
	PROD_BATES_SUFFIX = 'PROD_BATES_SUFFIX',

	PROD_IMAGE_MULTIPAGE = 'PROD_IMAGE_MULTIPAGE',
	PROD_IMAGE_COUNT_MISMATCH = 'PROD_IMAGE_COUNT_MISMATCH',
	PROD_IMAGE_FORMAT_UNKNOWN = 'PROD_IMAGE_FORMAT_UNKNOWN',

	PROD_DOC_FILE_ISSUE = 'PROD_DOC_FILE_ISSUE',

	PROD_PARENT_MISSING = 'PROD_PARENT_MISSING',
	PROD_PARENT_AFTER = 'PROD_PARENT_AFTER',
	PROD_PARENT_NOT_ORDERED = 'PROD_PARENT_NOT_ORDERED',
	PROD_PARENT_CONFLICT = 'PROD_PARENT_CONFLICT',
	PROD_PARENT_BAD_ATT_BEG = 'PROD_PARENT_BAD_ATT_BEG',
	PROD_PARENT_MISORDERED = 'PROD_PARENT_MISORDERED',

	CFB_MISSING_SECTOR = 'CFB_MISSING_SECTOR',
	CFB_PARTIAL_SECTOR = 'CFB_PARTIAL_SECTOR',
	CFB_BAD_NUMBER_OF_DIFAT_SECTORS = 'CFB_BAD_NUMBER_OF_DIFAT_SECTORS',
	CFB_CHAIN_TOO_LONG = 'CFB_CHAIN_TOO_LONG',

	CFB_DIFSECT_NOT_SET = 'CFB_DIFSECT_NOT_SET',
	CFB_FATSECT_NOT_SET = 'CFB_FATSECT_NOT_SET',
	CFB_SECTOR_OUT_OF_RANGE = 'CFB_SECTOR_OUT_OF_RANGE',
	CFB_MINI_STREAM_NOT_64_MULT = 'CFB_MINI_STREAM_NOT_64_MULT',
	CFB_DIR_ENTRY_EMPTY_NAME = 'CFB_DIR_ENTRY_EMPTY_NAME',
	CFB_BAD_STEAM_DATA = 'CFB_BAD_STEAM_DATA',

	OLEPS_PROP_VALUE_NOT_PADDED = 'OLEPS_PROP_VALUE_NOT_PADDED',
	OLEPS_PROP_VALUE_NOT_ORDERED = 'OLEPS_PROP_VALUE_NOT_ORDERED',
	OLEPS_PROP_SET_CODEPAGE_MISSING = 'OLEPS_PROP_SET_CODEPAGE_MISSING',
	OLEPS_PROP_SET_CODEPAGE_UNKNOWN = 'OLEPS_PROP_SET_CODEPAGE_UNKNOWN',
	OLEPS_PROP_SET_WEIRD_FMTID = 'OLEPS_PROP_SET_WEIRD_FMTID',
	OLEPS_PROP_SET_UNWANTED_DICTIONARY = 'OLEPS_PROP_SET_UNWANTED_DICTIONARY',
	OLEPS_PROP_STREAM_UNUSED_BYTES = 'OLEPS_PROP_STREAM_UNUSED_BYTES',
}

export interface Warning {
	code: WarningCode;
	info?: string;
}

export type Warnings = Warning[];

export interface HasWarnings {
	warnings: Warning[];
}

export interface WithWarnings<T> extends HasWarnings {
	result: T;
}

export interface WithErrorsAndWarnings {
	errors: Warning[];
	warnings: Warning[];
}
